import type { ReactNode } from "react";
import "../styles/live.css";
import { Layout } from "../components/Layout";
import { LiveBenchmarkPanel } from "../components/LiveBenchmarkPanel";
import { RaceChronoLapPanel } from "../components/RaceChronoLapPanel";
import type { Session } from "../types/session";

interface LiveViewProps {
  statusBar: ReactNode;
  map: ReactNode;
  gauges: ReactNode;
  radioDrawer?: ReactNode;
  cameraPanel?: ReactNode;
  alertStrip?: ReactNode;
  alertDrawer?: ReactNode;
  connectionBanner?: ReactNode;
  sessions: Session[];
  activeSessionId: number | null;
}

export function LiveView({ sessions, activeSessionId, ...props }: LiveViewProps) {
  return (
      <Layout
        {...props}
        benchmark={
          <div className="live-bottom-stack">
            <RaceChronoLapPanel topicPrefix="lemons/" />
            <LiveBenchmarkPanel
              sessions={sessions}
              activeSessionId={activeSessionId}
            />
          </div>
        }
      />
    );
}
